import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.pexels.com/photos/35726122/pexels-photo-35726122.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200"
          alt="Solaranlage"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="overline text-white/80">KAYSER</div>
          <h1 className="font-heading text-4xl font-bold tracking-tight mt-3 max-w-md">
            Alle Projekte an einem Ort.
          </h1>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm space-y-8" data-testid="login-container">
          <div>
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_infra-manager-15/artifacts/9lvbt023_Logo%20only%20kayser%20Kopie.png"
              alt="KAYSER"
              className="h-10 w-auto object-contain"
              data-testid="brand-logo"
            />
          </div>

          <div>
            <h2 className="font-heading text-3xl font-bold tracking-tight">Anmelden</h2>
            <p className="text-muted-foreground text-sm mt-1">Zurück zu deinem Arbeitsbereich.</p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4" autoComplete="off">
            <div className="space-y-1.5">
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                placeholder="name@firma.de"
                data-testid="login-email"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                placeholder="••••••••"
                data-testid="login-password"
              />
            </div>
            {error && (
              <div className="text-sm text-destructive" data-testid="login-error">{error}</div>
            )}
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? "Wird angemeldet …" : "Anmelden"}
            </Button>
          </form>

          <p className="text-sm text-muted-foreground">
            Noch keinen Zugang?{" "}
            <Link to="/register" className="text-primary font-medium hover:underline" data-testid="link-register">
              Konto erstellen
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
